import { adminRequest } from "./adminAuthApi";

// ── Types ─────────────────────────────────────────────────────────────────────

export interface PatientOut {
  id: string;
  name: string;
  email: string;
  phone: string;
  dob: string;
  gender: string;
  is_verified: boolean;
  is_disabled: boolean;
  created_at: string;
}

export interface PaginatedPatients {
  data: PatientOut[];
  total: number;
  page: number;
  limit: number;
}

export interface ListPatientsParams {
  page?: number;
  limit?: number;
  search?: string;
}

// ── Endpoints ─────────────────────────────────────────────────────────────────

/** Paginated, admin-auth-required. limit is capped at 100 server-side. Token is pulled from the admin auth store internally via apiClient. */
export const listPatientsApi = (params: ListPatientsParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", params.search);
  const qs = query.toString();

  return adminRequest<PaginatedPatients>(`/api/v1/admin/patients${qs ? `?${qs}` : ""}`, {
    method: "GET",
    protected: true,
  });
};

/** 404 if the patient doesn't exist. */
export const getPatientApi = (patientId: string) =>
  adminRequest<PatientOut>(`/api/v1/admin/patients/${patientId}`, { method: "GET", protected: true });
